export const legacyPasswordMessages = {
  match: '비밀번호가 일치합니다.',
  mismatch: '비밀번호가 일치하지 않습니다.',
  saved: 'Mock 비밀번호 변경을 완료했습니다. 실제 계정 비밀번호는 변경하지 않았습니다.',
}
